var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 1A.75.75 0 0 1 6 .25h11.25a.75.75 0 1 1 0 1.5H6A.75.75 0 0 1 5.25 1m12 5.25H6a.75.75 0 0 0 0 1.5h11.25a.75.75 0 1 0 0-1.5m0 6H6a.75.75 0 1 0 0 1.5h11.25a.75.75 0 1 0 0-1.5m-15-12H.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5m0 6H.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5m0 6H.75a.75.75 0 1 0 0 1.5h1.5a.75.75 0 1 0 0-1.5"
  })));
};
export default SvgList;